"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentEntityTitles = exports.ContentEntityTitlesDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var cn_1 = require("../../utils/cn");
var theme_1 = require("@shapeable/theme");
var content_title_1 = require("../elements/content-title");
var cls = (0, cn_1.classNames)('content-entity-titles');
exports.ContentEntityTitlesDefaultProps = {
  allowNameForTitle: false
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0 0 ", ";\n    font-size: ", "em;\n  "], ["\n    margin: 0;\n    padding: 0 0 ", ";\n    font-size: ", "em;\n  "])), theme_1.theme.UNIT(2), 20 / 16)
});
var PretitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0 0 ", ";\n    font-size: ", "em;\n    text-transform: uppercase;\n    font-weight: 300;\n    color: ", ";\n  "], ["\n    margin: 0;\n    padding: 0 0 ", ";\n    font-size: ", "em;\n    text-transform: uppercase;\n    font-weight: 300;\n    color: ", ";\n  "])), theme_1.theme.UNIT(2), 13 / 16, theme_1.theme.COLOR('text'))
});
var SubtitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0 0 ", ";\n    font-size: ", "em;\n    font-weight: 400;\n    color: ", ";\n  "], ["\n    margin: 0;\n    padding: 0 0 ", ";\n    font-size: ", "em;\n    font-weight: 400;\n    color: ", ";\n  "])), theme_1.theme.UNIT(2), 18 / 16, theme_1.theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.header(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Pretitle: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), PretitleStyles)
};
var ContentEntityTitles = function (props) {
  var className = props.className,
    entity = props.entity,
    allowNameForTitle = props.allowNameForTitle;
  var pretitle = entity.pretitle,
    title = entity.title,
    name = entity.name,
    subtitle = entity.subtitle;
  var hasPretitle = !!pretitle;
  var hasTitle = title || allowNameForTitle && name;
  var hasSubtitle = !!subtitle;
  if (!hasPretitle && !hasTitle && !hasSubtitle) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, pretitle && react_1.default.createElement(My.Pretitle, {
    className: cls.sub('pretitle')
  }, pretitle), (title || allowNameForTitle && name) && react_1.default.createElement(My.Title, null, title || name), subtitle && react_1.default.createElement(My.Subtitle, null, subtitle));
};
exports.ContentEntityTitles = ContentEntityTitles;
exports.ContentEntityTitles.defaultProps = exports.ContentEntityTitlesDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;